import UserProfile from "../../components/user/user-profile/UserProfile.tsx";
import AuthService from "../../services/auth/AuthService";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Navigate } from 'react-router-dom';
import type { RootState } from '../../store/store';

function UserProfilePage() {
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
    const [user, setUser] = useState(null);

    useEffect(() => {
        if (isLoggedIn) {
            AuthService.fetchCurrentUser().then(setUser);
        }
    }, [isLoggedIn]);

    if (!isLoggedIn)
        return <Navigate to="/login" replace />;

    return (
        <>
            <UserProfile user={user} />
        </>
    )
}

export default UserProfilePage;